import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoveExpandVertical = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "move-expand-vertical_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#move-expand-vertical_a)",
		children: /* @__PURE__ */ _jsx("path", { d: "M3.62 9.61a1.24 1.24 0 0 0 1.76 0l6.44-6.42a.25.25 0 0 1 .36 0l6.44 6.42a1.245 1.245 0 0 0 1.76-1.76L12.88.37a1.24 1.24 0 0 0-1.76 0l-7.5 7.48a1.24 1.24 0 0 0 0 1.76m16.76 4.78a1.24 1.24 0 0 0-1.76 0l-6.44 6.42a.25.25 0 0 1-.36 0l-6.44-6.42a1.244 1.244 0 1 0-1.76 1.76l7.5 7.48a1.23 1.23 0 0 0 1.76 0l7.5-7.48a1.24 1.24 0 0 0 0-1.76" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "move-expand-vertical_a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h24v24H0z" })
	}) })]
});
export { SvgMoveExpandVertical as ReactComponent };
